import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { VirtualConnectionTableQuery, VirtualConnectionTableQueryVariables, VirtualConnectionTableDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type VirtualConnectionTableQuery_virtualConnectionTables = Unpacked<VirtualConnectionTableQuery['virtualConnectionTables']>

export type VirtualConnectionTableQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: VirtualConnectionTableQuery_virtualConnectionTables) => React.ReactNode;
};

export class VirtualConnectionTableQueryWrapper extends React.Component<VirtualConnectionTableQueryWrapperProps> {

  public override render(): React.ReactNode {
    return (
      <Query<VirtualConnectionTableQuery, VirtualConnectionTableQueryVariables>
        query={VirtualConnectionTableDocument}
        variables={{ vizportalUrlId: this.props.vizportalUrlId }}
      >
        {result => <RenderQueryResult result={result} renderers={{
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderVirtualConnectionTableData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderVirtualConnectionTableData),
          renderError: renderError,
        }} />}
      </Query>
    );
  }

  private readonly renderVirtualConnectionTableData = (data: VirtualConnectionTableQuery): React.ReactNode => {
    const virtualConnectionTable = data.virtualConnectionTables ? data.virtualConnectionTables[0] : null;
    if (virtualConnectionTable) {
      return this.props.children(virtualConnectionTable);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
